<template>
  <div class="hb-bab-box pb-6">
      <div class="hb-title">STEP 1 OF 5</div>
      <div class="step-title">{{giftBoxSettings.section_title || 'Select your box'}}</div>
      <p v-html="giftBoxSettings.section_description"></p>
      <div v-if="loading" class="d-flex justify-center">
        <v-progress-circular
            indeterminate
            color="primary"
        ></v-progress-circular>
      </div>
      <div class="d-flex" :class="{'flex-column': $vuetify.breakpoint.mdAndDown, 'flex-wrap': $vuetify.breakpoint.lgAndUp}" v-else>
        <box-card v-for="box in giftBoxes" :key="box.id" :boxData="box" @next="$emit('next')"></box-card>
      </div>

  </div>
</template>

<script>
import BoxCard from './BoxCard.vue';
import { getBab } from '../../api/products';
import { TYPE_SET_BOX_SETTINGS, TYPE_SET_PRODUCT_DETAILS } from '../../store/mutations';

export default {
    name: 'hb-bab-box',
    components:{
        BoxCard
    },
    data(){
        return{
            loading: true
        }
    },
    async mounted(){
        const bab = await getBab();
        this.$store.commit(TYPE_SET_PRODUCT_DETAILS, bab);
        this.$store.commit(TYPE_SET_BOX_SETTINGS, bab.box_settings)
        this.loading = false;
    },
    computed:{
        giftBoxes(){
            return this.$store.state.giftBoxes;
        },
        giftBoxSettings(){
            if(!this.$store.state?.boxSettings?.gift_boxes){
                return {
                section_title: '',
                section_description: ''
                }
            }
            return this.$store.state.boxSettings?.gift_boxes
        }
    }
}
</script>

<style>
@media screen and (min-width: 768px) {
    .boxcard{
        margin-left: 0.5rem;
        margin-right: 0.5rem;
        margin-bottom: 1rem;
    }
}
</style>